export default {
  'pages.layouts.userLayout.title': '打造全球开放式小游戏生态',
  'pages.login.platformTitle': 'PlaysOut开发者平台',
  'pages.login.gameEnginesTitle': '全方位兼容以下游戏引擎',
  'pages.login.partnersTitle': '合作伙伴',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.admin.playerChannelManagement.description': '查询和修改玩家渠道信息',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // 游戏管理
  'pages.games.createModal.title': '新增小游戏',
  'pages.games.createModal.gameName': '小游戏名称',
  'pages.games.createModal.gameName.placeholder': '请输入小游戏名称',
  'pages.games.createModal.category': '小游戏分类',
  'pages.games.createModal.category.required': '请至少选择一个分类',
  'pages.games.createModal.category.max': '最多选择三个分类',
  'pages.games.createModal.description': '小游戏简介',
  'pages.games.createModal.description.placeholder': '请输入游戏简介',
  'pages.games.createModal.icon': '游戏图标',
  'pages.games.createModal.icon.required': '请上传游戏图标',
  'pages.games.createModal.icon.tips': '只能上传 jpg/jpeg/png 文件，分辨率建议为512x512，且文件大小不能超过 2M',
  'pages.games.createModal.screenshots': '截图',
  'pages.games.createModal.screenshots.tips': '最多上传 5 张图片，宽高尺寸不低于1080*1920px，只能上传 jpg、jpeg、bmp、gif、png 文件，文件大小不能超过5 MB',
  'pages.games.createModal.detail': '小游戏描述',
  'pages.games.createModal.detail.placeholder': '请输入详细游戏描述',
  'pages.games.createModal.cancel': '取消',
  'pages.games.createModal.submit': '提交',
  'pages.games.createModal.return.success': '游戏创建成功！',
  'pages.games.createModal.return.failure': '游戏创建失败，请重试！',

  // 新增验证信息
  'pages.games.createModal.validation.iconFileType': '只能上传 JPG/PNG 格式的图标！',
  'pages.games.createModal.validation.iconFileSize': '图标文件大小不能超过 2MB！',
  'pages.games.createModal.validation.createFailed': '游戏创建失败',

  // 新增分类选项（放在已有分类配置下方）
  'pages.games.createModal.category.options.Action': '动作',
  'pages.games.createModal.category.options.Adventure': '冒险',
  'pages.games.createModal.category.options.Arcade': '街机',
  'pages.games.createModal.category.options.Card': '卡牌',
  'pages.games.createModal.category.options.FPS': '射击',
  'pages.games.createModal.category.options..io': '.io',
  'pages.games.createModal.category.options.Puzzle': '解谜',
  'pages.games.createModal.category.options.RPG': '角色扮演',
  'pages.games.createModal.category.options.Sports': '运动',
  'pages.games.createModal.category.options.Tower Defense': '塔防',
  'pages.games.createModal.category.options.Simulator': '养成',



  'pages.games.table.columns.name': '游戏名称',
  'pages.games.table.columns.category': '游戏类型',
  'pages.games.table.columns.updateDate': '更新日期',
  'pages.games.table.columns.createDate': '创建日期',
  'pages.games.table.columns.actions': '操作',
  'pages.games.table.actions.manage': '管理',

  'pages.games.filter.button': '筛选',
  'pages.games.filter.status.all': '全部',
  'pages.games.filter.status.active': '活跃',
  'pages.games.filter.status.inactive': '非活跃',

  'pages.games.category.casual': '休闲',
  'pages.games.category.puzzle': '解谜',
  'pages.games.category.action': '动作',
  'pages.games.category.simulation': '养成',

  'pages.games.modal.filter.title': '筛选条件',
  'pages.games.log.close': '弹窗关闭，已触发列表刷新',
  'pages.games.log.refresh': '数据刷新完成',

  'pages.games.search.placeholder': '搜索游戏名称',
  'pages.games.modal.cancel': '取消',
  'pages.games.modal.confirm': '确定',
  'pages.games.create.button': '新增游戏',

  // 在现有配置下方新增
  'pages.games.detail.title': '游戏详情',
  'pages.games.detail.basicInfo': '基本信息',
  'pages.games.detail.name': '名称：',
  'pages.games.detail.appId': 'AppID：',
  'pages.games.detail.category': '分类：',
  'pages.games.detail.summary': '简介：',
  'pages.games.detail.description': '描述：',
  'pages.games.version.management': '版本管理',
  'pages.games.gray.publish': '灰度发布',
  'pages.games.privacy.settings': '隐私设置',
  'pages.games.upload.progress': '上传中 {percent}%',
  'pages.games.upload.success': '上传成功',
  'pages.games.upload.error': '上传失败',
  'pages.games.publish.title': '确认发布灰度版本？',
  'pages.games.publish.content': '该操作将覆盖当前线上版本',
  'pages.games.review.submit': '提交审核',
  'pages.games.review.success': '已提交审核',
  'pages.games.review.error': '提交审核失败',
  'pages.games.publish.success': '灰度版本发布成功',
  'pages.games.publish.error': '发布失败',
  'pages.games.version.online': '线上版本',
  'pages.games.version.viewData': '查看数据',
  'pages.games.version.notOnline': '当前游戏还未上线',
  'pages.games.review.auditing': '审核中，请耐心等待',
  'pages.games.review.rejectReason': '原因：',
  'pages.games.review.rejected': '审核未通过',
  'pages.games.review.approved': '恭喜，审核已通过！',
  'pages.games.version.grayVersion': '灰度版本',
  'pages.games.version.currentGray': '当前灰度版本：v{version}',
  'pages.games.version.devVersion': '开发版本',
  'pages.games.upload.submit': '提交新开发版本',
  'pages.games.upload.tips': '仅支持上传ZIP格式文件，文件大小不超过30MB',
  'pages.games.version.uploadFirst': '请先上传开发版本',
  'pages.games.publish.button': '立即发布',
  'pages.games.review.title': '确认提交审核？',
  'pages.games.review.content': '提交后将在1-3个工作日内完成审核',
  'pages.games.review.button': '提交审核',
  'pages.games.upload.uploading': '上传中...',
  'pages.games.upload.zipOnly': '仅支持ZIP格式文件',
  'pages.games.upload.sizeLimit': '文件大小不能超过30MB',
  'pages.games.review.auditPrompt': '当前游戏正在审核中，请耐心等待',
  'pages.games.upload.submitDevVersion': '提交新开发版本',
  'pages.games.detail.detailedInfo': '详细信息',

  'pages.games.purchase.settings': '内购设置',
  'pages.games.purchase.settingsTitle': '应用内购买配置',
  'pages.games.purchase.comingSoon': '功能开发中，敬请期待',
  'pages.games.purchase.enabled': '已启用',
  'pages.games.purchase.disabled': '已禁用',
  'pages.games.purchase.placeholder': '请输入回调地址',
  'pages.games.purchase.test': '测试配置',
  'pages.games.purchase.submit': '保存配置',
  'pages.games.purchase.emptyError': '配置内容不能为空',
  'pages.games.purchase.success': '配置保存成功',
  'pages.games.purchase.error': '配置保存失败',
  'pages.games.purchase.urlPlaceholder': '请输入有效的内购配置URL（例如：https://api.example.com/config）',
  'pages.games.purchase.invalidUrl': '请输入有效的URL地址',
  'pages.games.purchase.statusUpdateSuccess': '状态更新成功',
  'pages.games.purchase.statusUpdateError': '状态更新失败，请重试',


  'pages.gameManagement.table.columns.name': '游戏名称',
  'pages.gameManagement.table.columns.category': '游戏类型',
  'pages.gameManagement.table.columns.updateDate': '更新日期',
  'pages.gameManagement.table.columns.createDate': '创建日期',
  'pages.gameManagement.table.columns.actions': '操作',

  'pages.gameManagement.modal.title': '游戏详情管理',
  'pages.gameManagement.modal.basicInfo': '基本信息',
  'pages.gameManagement.modal.reviewComment': '审核意见',
  'pages.gameManagement.modal.actions.close': '关闭',
  'pages.gameManagement.modal.actions.reject': '驳回',
  'pages.gameManagement.modal.actions.approve': '通过',

  'pages.gameManagement.review.comment.placeholder': '请输入审核意见',
  'pages.gameManagement.qrCode.text': '扫码体验游戏',
  'pages.gameManagement.review.messages.noSelection': '未选择游戏',
  'pages.gameManagement.review.messages.approveSuccess': '审核通过成功',
  'pages.gameManagement.review.messages.rejectSuccess': '驳回操作成功',
  'pages.gameManagement.review.messages.operationFailed': '操作失败: {msg}',
  'pages.gameManagement.review.messages.retryLater': '操作失败，请稍后重试',

  'pages.gameManagement.status.published': '已发布',
  'pages.gameManagement.status.underReview': '审核中',

  'pages.login.googleSignIn': '使用 Google 登录',
  'pages.gameManagement.table.columns.gameId': '游戏ID',
  'pages.gameManagement.table.columns.status': '状态',
  'pages.gameManagement.offline.button': '下架',
  'pages.gameManagement.offline.confirm': '确认要下架该游戏吗？',

  "pages.games.detail.modifyIcon": "修改图标",
  "pages.games.detail.saveIcon": "保存修改",
  "pages.games.detail.icon.required": "请先选择新图标",
  "pages.games.detail.icon.success": "图标更新成功",
  "pages.games.detail.icon.error": "图标更新失败",
  "pages.admin.inviteUser.description": "通过邮箱邀请新用户加入系统",
  'pages.admin.game-analytics.description': '游戏运营数据统计与分析',

  "pages.games.detail.help": "帮助",
  "pages.games.detail.help.title": "字段说明",
  "pages.games.detail.help.content": "AppID--> offerId \n Purchase Key--> AppKey",

  // 游戏删除相关
  "pages.games.delete.button": "删除游戏",
  "pages.games.delete.inputPlaceholder": "请输入游戏名称 '{gameName}' 以确认删除",
  "pages.games.delete.confirmButton": "确认删除",
  "pages.games.delete.cancelButton": "取消",
  "pages.games.delete.confirm.title": "确认删除游戏",
  "pages.games.delete.confirm.content": "删除后将无法恢复，是否确认删除？",
  "pages.games.delete.confirm.ok": "确认删除",
  "pages.games.delete.confirm.cancel": "取消",
  "pages.games.delete.success": "游戏删除成功",
  "pages.games.delete.error": "游戏删除失败",

  // SDK User - Credentials
  "pages.sdkUser.credentials.defaultProjectName": "游戏平台SDK",
  "pages.sdkUser.credentials.noChannelInfo": "目前还没有渠道信息，请先创建渠道",
  "pages.sdkUser.credentials.copySuccess": "SDK Key 已复制到剪切板",
  "pages.sdkUser.credentials.copyFailed": "复制失败，请手动复制",
  "pages.sdkUser.credentials.showCreateModal": "显示创建弹框",
  "pages.sdkUser.credentials.showUpdateModal": "显示更新弹框:",
  "pages.sdkUser.credentials.updateSuccess": "SDK Key 更新成功",
  "pages.sdkUser.credentials.generateSuccess": "SDK Key 生成成功",
  "pages.sdkUser.credentials.updateFailed": "更新SDK Key失败",
  "pages.sdkUser.credentials.generateFailed": "生成SDK Key失败",
  "pages.sdkUser.credentials.requestFailed": "请求失败，请稍后重试",
  "pages.sdkUser.credentials.validationFailed": "表单验证失败:",
  "pages.sdkUser.credentials.table.platform": "Platform",
  "pages.sdkUser.credentials.table.packageName": "Package Name",
  "pages.sdkUser.credentials.table.sdkKey": "SDK Key",
  "pages.sdkUser.credentials.table.validityStart": "Validity Start",
  "pages.sdkUser.credentials.table.validityEnd": "Validity End",
  "pages.sdkUser.credentials.table.status": "Status",
  "pages.sdkUser.credentials.table.actions": "Actions",
  "pages.sdkUser.credentials.action.view": "查看",
  "pages.sdkUser.credentials.action.hide": "隐藏",
  "pages.sdkUser.credentials.action.update": "更新",
  "pages.sdkUser.credentials.stat.activeKeys": "Active Keys",
  "pages.sdkUser.credentials.stat.inactiveKeys": "Inactive Keys",
  "pages.sdkUser.credentials.empty": "暂无凭证数据",
  "pages.sdkUser.credentials.modal.updateTitle": "Update SDK Key",
  "pages.sdkUser.credentials.modal.generateTitle": "Generate New SDK Key",
  "pages.sdkUser.credentials.modal.updateButton": "Update",
  "pages.sdkUser.credentials.modal.generateButton": "Generate",
  "pages.sdkUser.credentials.modal.cancelButton": "Cancel",
  "pages.sdkUser.credentials.form.platform": "Platform",
  "pages.sdkUser.credentials.form.platformRequired": "请选择平台",
  "pages.sdkUser.credentials.form.platformPlaceholder": "Select platform",
  "pages.sdkUser.credentials.form.android": "Android",
  "pages.sdkUser.credentials.form.ios": "iOS",
  "pages.sdkUser.credentials.form.packageName": "Package Name",
  "pages.sdkUser.credentials.form.packageNameRequired": "请输入包名",
  "pages.sdkUser.credentials.form.packageNamePlaceholder": "Enter package name (e.g. com.example.game)",
  "pages.sdkUser.credentials.form.validDays": "Valid Days",
  "pages.sdkUser.credentials.form.validDaysRequired": "请选择有效期天数",
  "pages.sdkUser.credentials.form.validDaysMin": "有效期天数必须在1到9999之间",
  "pages.sdkUser.credentials.form.validDaysPlaceholder": "Select valid days",
  "pages.sdkUser.credentials.form.day30": "1 Month (30 days)",
  "pages.sdkUser.credentials.form.day365": "1 Year (365 days)",
  "pages.sdkUser.credentials.form.day730": "2 Years (730 days)",
  "pages.sdkUser.credentials.form.day3650": "10 Years (3650 days)",
  "pages.sdkUser.credentials.form.day36500": "100 Years (36500 days)",
  "pages.sdkUser.credentials.title": "{projectName} Credentials",
  "pages.sdkUser.credentials.description": "Manage Channel IDs and SDK Keys for this project.",
  "pages.sdkUser.credentials.generateButton": "+ Generate New Key",

  // SDK User - Projects
  "pages.sdkUser.projects.loadCacheFailed": "加载缓存数据失败:",
  "pages.sdkUser.projects.fetchFailed": "获取渠道列表失败",
  "pages.sdkUser.projects.userNotLoggedIn": "用户未登录或邮箱信息未获取",
  "pages.sdkUser.projects.createSuccess": "项目创建成功",
  "pages.sdkUser.projects.createFailed": "项目创建失败",
  "pages.sdkUser.projects.createRetry": "创建项目失败，请稍后重试",
  "pages.sdkUser.projects.deleteConfirmTitle": "确认删除",
  "pages.sdkUser.projects.deleteConfirmContent": "确定要删除项目\"{name}\"吗？此操作不可恢复。",
  "pages.sdkUser.projects.deleteConfirmButton": "确认删除",
  "pages.sdkUser.projects.deleteCancelButton": "取消",
  "pages.sdkUser.projects.deleteSuccess": "项目删除成功",
  "pages.sdkUser.projects.deleteFailed": "项目删除失败",
  "pages.sdkUser.projects.deleteRetry": "删除项目失败，请稍后重试",
  "pages.sdkUser.projects.movedToFirst": "已将项目移到缓存第一个位置:",
  "pages.sdkUser.projects.table.name": "项目名称",
  "pages.sdkUser.projects.table.status": "状态",
  "pages.sdkUser.projects.table.statusActive": "活跃",
  "pages.sdkUser.projects.table.statusInactive": "未激活",
  "pages.sdkUser.projects.table.type": "类型",
  "pages.sdkUser.projects.table.typeMobile": "移动游戏",
  "pages.sdkUser.projects.table.typePC": "PC游戏",
  "pages.sdkUser.projects.table.createdAt": "创建时间",
  "pages.sdkUser.projects.table.updatedAt": "更新时间",
  "pages.sdkUser.projects.table.actions": "操作",
  "pages.sdkUser.projects.action.manage": "管理",
  "pages.sdkUser.projects.action.delete": "删除",
  "pages.sdkUser.projects.title": "项目列表",
  "pages.sdkUser.projects.createButton": "新建项目",
  "pages.sdkUser.projects.empty": "您还没有创建任何项目",
  "pages.sdkUser.projects.createFirstButton": "创建第一个项目",
  "pages.sdkUser.projects.modal.title": "新建项目",
  "pages.sdkUser.projects.form.name": "项目名称",
  "pages.sdkUser.projects.form.namePlaceholder": "请输入项目名称",
  "pages.sdkUser.projects.form.nameRequired": "请输入项目名称",
  "pages.sdkUser.projects.form.nameLength": "项目名称长度需在3-50个字符之间",
  "pages.sdkUser.projects.form.namePattern": "项目名称只允许英文字母、数字和下划线，不允许空格和特殊字符",
  "pages.sdkUser.projects.form.nameMustContainLetter": "项目名称必须包含至少一个英文字母",
  "pages.sdkUser.projects.form.type": "项目类型",
  "pages.sdkUser.projects.form.typePlaceholder": "请选择项目类型",
  "pages.sdkUser.projects.form.typeRequired": "请选择项目类型",
  "pages.sdkUser.projects.form.description": "项目描述",
  "pages.sdkUser.projects.form.descriptionPlaceholder": "请输入项目描述",
  "pages.sdkUser.projects.form.submitButton": "创建项目",
  "pages.sdkUser.projects.form.noDescription": "暂无描述",

  // SDK User - ProjectDetail
  "pages.sdkUser.projectDetail.title": "Project: {name}",
  "pages.sdkUser.projectDetail.loadCacheFailed": "加载缓存数据失败:",
  "pages.sdkUser.projectDetail.loadFailed": "获取项目数据失败:",
  "pages.sdkUser.projectDetail.loadStatsFailed": "获取渠道统计数据失败:",
  "pages.sdkUser.projectDetail.table.date": "日期",
  "pages.sdkUser.projectDetail.table.users": "用户数",
  "pages.sdkUser.projectDetail.table.revenue": "收入",
  "pages.sdkUser.projectDetail.table.dau": "DAU",
  "pages.sdkUser.projectDetail.typeMobile": "移动游戏",
  "pages.sdkUser.projectDetail.typePC": "PC游戏",
  "pages.sdkUser.projectDetail.noDescription": "暂无描述",
  "pages.sdkUser.projectDetail.defaultDescription": "Analytics overview for your Mobile Game workspace.",
  "pages.sdkUser.projectDetail.notFound": "找不到指定的项目信息",
  "pages.sdkUser.projectDetail.cardTitle": "项目详情",
  "pages.sdkUser.projectDetail.integration.title": "Integrate {name}",
  "pages.sdkUser.projectDetail.integration.description": "Get the keys specific to this project to start tracking users and sessions immediately.",
  "pages.sdkUser.projectDetail.integration.manageButton": "Manage SDK Keys",
  "pages.sdkUser.projectDetail.integration.docsButton": "Documentation",
  "pages.sdkUser.projectDetail.manageGamesButton": "小游戏管理",
  "pages.sdkUser.projectDetail.stats.liveStats": "Live Stats",
  "pages.sdkUser.projectDetail.stats.totalUsers": "Total Users",
  "pages.sdkUser.projectDetail.stats.dau": "DAU",
  "pages.sdkUser.projectDetail.stats.revenue": "Revenue",
  "pages.sdkUser.projectDetail.stats.usersTrend": "Users Trend",
  "pages.sdkUser.projectDetail.stats.growthTracking": "Growth tracking for the last 7 days",
  "pages.sdkUser.projectDetail.stats.dauRevenueTrends": "DAU & Revenue Trends",
  "pages.sdkUser.projectDetail.guides.title": "Integration Guides",
  "pages.sdkUser.projectDetail.guides.android.title": "Android SDK",
  "pages.sdkUser.projectDetail.guides.android.docsButton": "View Documentation",
  "pages.sdkUser.projectDetail.guides.android.name": "PlaysOut SDK demo for Android",
  "pages.sdkUser.projectDetail.guides.android.description": "Full source code and implementation guide for native Android game integration.",
  "pages.sdkUser.projectDetail.guides.ios.title": "iOS SDK",
  "pages.sdkUser.projectDetail.guides.ios.docsButton": "View Documentation",
  "pages.sdkUser.projectDetail.guides.ios.name": "PlaysOut SDK demo for IOS",
  "pages.sdkUser.projectDetail.guides.ios.description": "Swift-ready demo project to accelerate your iOS deployment and session tracking.",
  "pages.sdkUser.projectDetail.guides.other.title": "Other Guides",
  "pages.sdkUser.projectDetail.guides.other.docsButton": "View Documentation",
  "pages.sdkUser.projectDetail.guides.other.name": "Other Guides",
  "pages.sdkUser.projectDetail.guides.other.description": "Explore documentation for WebGL, Unity, and cross-platform custom engine wrappers.",

  // SDK User - Game Selection
  "pages.sdkUser.gameSelection.title": "游戏精选管理",
  "pages.sdkUser.gameSelection.selectedGames": "我的精选游戏",
  "pages.sdkUser.gameSelection.availableGames": "游戏库",
  "pages.sdkUser.gameSelection.searchPlaceholder": "搜索游戏名称",
  "pages.sdkUser.gameSelection.allCategories": "全部分类",
  "pages.sdkUser.gameSelection.add": "加入",
  "pages.sdkUser.gameSelection.remove": "移出",
  "pages.sdkUser.gameSelection.saveButton": "保存精选 ({count})",
  "pages.sdkUser.gameSelection.clearButton": "清空全部",
  "pages.sdkUser.gameSelection.refreshButton": "刷新",
  "pages.sdkUser.gameSelection.dragHint": "拖拽可调整顺序",
  "pages.sdkUser.gameSelection.updatedAt": "更新于 {date}",
  "pages.sdkUser.gameSelection.empty.selected": "暂无精选游戏",
  "pages.sdkUser.gameSelection.empty.available": "暂无可用游戏",
  "pages.sdkUser.gameSelection.saveSuccess": "保存成功",
  "pages.sdkUser.gameSelection.clearSuccess": "已清空所有精选游戏",
  "pages.sdkUser.gameSelection.clearConfirm.title": "确认清空",
  "pages.sdkUser.gameSelection.clearConfirm.content": "确定要清空所有精选游戏吗？此操作不可恢复。",
  "pages.sdkUser.gameSelection.clearConfirm.ok": "确认清空",
  "pages.sdkUser.gameSelection.clearConfirm.cancel": "取消",
  "pages.sdkUser.gameSelection.error.noUser": "无法获取用户信息",
  "pages.sdkUser.gameSelection.error.loadFailed": "加载游戏列表失败",
  "pages.sdkUser.gameSelection.error.saveFailed": "保存失败，请稍后重试",
  "pages.sdkUser.gameSelection.warning.noSelection": "请至少选择一个游戏",

  // SDK User - Project Detail New
  "pages.sdkUser.projectDetailNew.tab.detail": "小游戏详情",
  "pages.sdkUser.projectDetailNew.tab.games": "小游戏管理",
  "pages.sdkUser.projectDetailNew.tab.selection": "小游戏推荐列表",
  "pages.sdkUser.projectDetailNew.warning.noProject": "无法获取项目信息",
  "pages.sdkUser.projectDetailNew.games.empty.description": "管理该渠道的小游戏，包括创建、编辑和发布游戏",
  "pages.sdkUser.projectDetailNew.games.manageButton": "进入小游戏管理",
  "pages.sdkUser.projectDetail.error.loadFailed": "获取项目数据失败",

  // Home Page - Admin Dashboard
  "pages.home.admin.title": "管理员控制台",
  "pages.home.admin.welcome": "欢迎回来，{name}！系统运行正常",
  "pages.home.admin.stat.totalUsers": "总用户数",
  "pages.home.admin.stat.totalGames": "游戏总数",
  "pages.home.admin.stat.pendingReview": "待审核",
  "pages.home.admin.stat.todayVisits": "今日访问",
  "pages.home.admin.section.management": "管理功能",
  "pages.home.admin.card.userManagement": "用户管理",
  "pages.home.admin.card.userManagement.desc": "邀请和管理系统用户",
  "pages.home.admin.card.gameAnalytics": "游戏分析",
  "pages.home.admin.card.gameAnalytics.desc": "查看游戏数据分析",
  "pages.home.admin.card.cdnManagement": "CDN管理",
  "pages.home.admin.card.cdnManagement.desc": "配置和管理CDN资源",
  "pages.home.admin.card.channelManagement": "渠道管理",
  "pages.home.admin.card.channelManagement.desc": "管理玩家渠道配置",
  "pages.home.admin.section.announcements": "系统公告",
  "pages.home.admin.announcement.latest": "最新",
  "pages.home.admin.announcement.normal": "系统正常运行",
  "pages.home.admin.announcement.normal.desc": "所有服务运行正常，无需关注",
  "pages.home.admin.announcement.update": "更新",
  "pages.home.admin.announcement.update.title": "功能优化",
  "pages.home.admin.announcement.update.desc": "管理后台功能持续优化中",

  // Home Page - User Dashboard
  "pages.home.user.welcome": "欢迎回来，{name}！",
  "pages.home.user.subtitle": "开始创建和管理您的游戏项目",
  "pages.home.user.stat.myGames": "我的游戏",
  "pages.home.user.stat.totalUsers": "总用户数",
  "pages.home.user.stat.todayActive": "今日活跃",
  "pages.home.user.stat.totalRevenue": "总收入",
  "pages.home.user.section.quickActions": "快捷操作",
  "pages.home.user.card.gameManagement": "游戏管理",
  "pages.home.user.card.gameManagement.desc": "创建和管理游戏项目",
  "pages.home.user.card.statistics": "统计分析",
  "pages.home.user.card.statistics.desc": "查看游戏数据和用户分析",
  "pages.home.user.card.playerAnalytics": "玩家分析",
  "pages.home.user.card.playerAnalytics.desc": "深入了解玩家行为",
  "pages.home.user.card.createGame": "创建游戏",
  "pages.home.user.card.createGame.desc": "快速创建新游戏项目",
  "pages.home.user.section.features": "平台特性",
  "pages.home.user.feature.secure": "安全可靠",
  "pages.home.user.feature.secure.desc": "企业级安全保障",
  "pages.home.user.feature.flexible": "灵活接入",
  "pages.home.user.feature.flexible.desc": "完善的SDK支持",
  "pages.home.user.feature.performance": "高性能",
  "pages.home.user.feature.performance.desc": "全球节点部署",
  "pages.home.user.feature.global": "全球化",
  "pages.home.user.feature.global.desc": "服务全球用户",

  // Home Page - Reviewer Dashboard
  "pages.home.reviewer.title": "审核员工作台",
  "pages.home.reviewer.welcome": "欢迎回来，{name}！待审核任务：0",
  "pages.home.reviewer.stat.pending": "待审核",
  "pages.home.reviewer.stat.approved": "已通过",
  "pages.home.reviewer.stat.rejected": "已拒绝",
  "pages.home.reviewer.stat.todayReviews": "今日审核",
  "pages.home.reviewer.section.tasks": "审核任务",
  "pages.home.reviewer.card.pending": "待审核",
  "pages.home.reviewer.card.pending.desc": "查看待审核游戏",
  "pages.home.reviewer.card.history": "审核历史",
  "pages.home.reviewer.card.history.desc": "查看审核记录",
  "pages.home.reviewer.card.gameList": "游戏列表",
  "pages.home.reviewer.card.gameList.desc": "查看所有游戏",
  "pages.home.reviewer.card.dataAnalysis": "数据分析",
  "pages.home.reviewer.card.dataAnalysis.desc": "查看游戏数据",
  "pages.home.reviewer.section.guide": "审核指南",
  "pages.home.reviewer.guide.tip": "提示",
  "pages.home.reviewer.guide.standard": "审核标准",
  "pages.home.reviewer.guide.standard.desc": "请仔细检查游戏内容、图标、描述等信息",
  "pages.home.reviewer.guide.norm": "规范",
  "pages.home.reviewer.guide.process": "审核流程",
  "pages.home.reviewer.guide.process.desc": "查看游戏详情，检查内容，做出审核决定",

  // Home Page - SDK User Dashboard
  "pages.home.sdkUser.title": "SDK用户中心",
  "pages.home.sdkUser.welcome": "欢迎回来，{name}！",
  "pages.home.sdkUser.stat.myProjects": "我的项目",
  "pages.home.sdkUser.stat.sdkCredentials": "SDK凭证",
  "pages.home.sdkUser.stat.activeProjects": "活跃项目",
  "pages.home.sdkUser.stat.totalCalls": "总调用次数",
  "pages.home.sdkUser.section.projectManagement": "项目管理",
  "pages.home.sdkUser.card.projectList": "项目列表",
  "pages.home.sdkUser.card.projectList.desc": "管理您的SDK项目",
  "pages.home.sdkUser.card.credentials": "SDK凭证",
  "pages.home.sdkUser.card.credentials.desc": "管理SDK密钥和凭证",
  "pages.home.sdkUser.card.createProject": "创建项目",
  "pages.home.sdkUser.card.createProject.desc": "创建新的SDK项目",
  "pages.home.sdkUser.card.apiDocs": "API文档",
  "pages.home.sdkUser.card.apiDocs.desc": "查看API使用文档",
  "pages.home.sdkUser.section.features": "SDK特性",
  "pages.home.sdkUser.feature.secure": "安全认证",
  "pages.home.sdkUser.feature.secure.desc": "多重安全保障",
  "pages.home.sdkUser.feature.performance": "高性能",
  "pages.home.sdkUser.feature.performance.desc": "低延迟高并发",
  "pages.home.sdkUser.feature.integration": "易于集成",
  "pages.home.sdkUser.feature.integration.desc": "完善的SDK文档",
  "pages.home.sdkUser.feature.global": "全球服务",
  "pages.home.sdkUser.feature.global.desc": "全球节点覆盖",

  // SDK User - Game Management
  "pages.sdkUser.gameManagement.title": "小游戏管理",
  "pages.sdkUser.gameManagement.description": "在这里进行游戏管理",
  "pages.sdkUser.gameManagement.refresh": "刷新",
  "pages.sdkUser.gameManagement.filter": "筛选",
  "pages.sdkUser.gameManagement.create": "新增游戏",
  "pages.sdkUser.gameManagement.table.name": "游戏名称",
  "pages.sdkUser.gameManagement.table.category": "游戏分类",
  "pages.sdkUser.gameManagement.table.status": "状态",
  "pages.sdkUser.gameManagement.table.updateDate": "更新日期",
  "pages.sdkUser.gameManagement.table.createDate": "创建日期",
  "pages.sdkUser.gameManagement.table.actions": "操作",
  "pages.sdkUser.gameManagement.action.manage": "管理",
  "pages.sdkUser.gameManagement.category.casual": "休闲",
  "pages.sdkUser.gameManagement.category.puzzle": "益智",
  "pages.sdkUser.gameManagement.category.action": "动作",
  "pages.sdkUser.gameManagement.category.simulation": "模拟",
  "pages.sdkUser.gameManagement.status.active": "已上架",
  "pages.sdkUser.gameManagement.status.inactive": "待上架",
  "pages.sdkUser.gameManagement.filter.status.all": "全部",
  "pages.sdkUser.gameManagement.filter.status.active": "已上架",
  "pages.sdkUser.gameManagement.filter.status.inactive": "待上架",
  "pages.sdkUser.gameManagement.filter.title": "筛选条件",
  "pages.sdkUser.gameManagement.createModal.title": "新增游戏",
  "pages.sdkUser.gameManagement.createModal.comingSoon": "此功能即将上线，敬请期待！",
  "pages.sdkUser.gameManagement.detailModal.title": "游戏详情",
  "pages.sdkUser.gameManagement.detail.category": "分类",
  "pages.sdkUser.gameManagement.detail.status": "状态",
  "pages.sdkUser.gameManagement.detail.description": "描述",
  "pages.sdkUser.gameManagement.detail.created": "创建时间",
  "pages.sdkUser.gameManagement.detail.updated": "更新时间",
  "pages.sdkUser.gameManagement.detail.noDescription": "暂无描述",
  "pages.sdkUser.gameManagement.modal.confirm": "确认",
  "pages.sdkUser.gameManagement.modal.cancel": "取消",
  "pages.sdkUser.gameManagement.empty": "暂无游戏数据",
  "pages.sdkUser.gameManagement.error.loadFailed": "加载游戏列表失败",
  "pages.sdkUser.gameManagement.error.noChannel": "未找到渠道信息",
  "pages.sdkUser.gameManagement.tabs.detail": "小游戏详情",
  "pages.sdkUser.gameManagement.tabs.management": "游戏管理",
  "pages.sdkUser.gameManagement.tabs.recommendation": "推荐管理",
  "pages.sdkUser.gameManagement.detailTab.empty": "小游戏详情功能开发中，敬请期待",
  "pages.sdkUser.gameManagement.recommendationTab.empty": "推荐管理功能开发中，敬请期待",
  "pages.sdkUser.gameManagement.search.placeholder": "Search games...",
  "pages.sdkUser.gameManagement.action.publish": "上架",
  "pages.sdkUser.gameManagement.action.unpublish": "下架",
  "pages.sdkUser.gameManagement.table.activeUsers": "活跃用户",
  "pages.sdkUser.gameManagement.table.retention1Day": "次日留存",
  "pages.sdkUser.gameManagement.table.retention7Day": "7日留存",
  "pages.sdkUser.gameManagement.table.adImpressions": "广告展示数",
  "pages.sdkUser.gameManagement.table.adRevenue": "广告收入",
  "pages.sdkUser.gameManagement.detail.stats.totalGames": "总游戏数",
  "pages.sdkUser.gameManagement.detail.stats.gamePlayers": "游戏玩家数",
  "pages.sdkUser.gameManagement.detail.stats.avgPlayTime": "总启动次数",
  "pages.sdkUser.gameManagement.detail.stats.gameRevenue": "游戏收入",
  "pages.sdkUser.gameManagement.detail.ranking.title": "热门游戏收入排行",
  "pages.sdkUser.gameManagement.detail.ranking.viewDetails": "查看详情",
  "pages.sdkUser.gameManagement.detail.table.activeUsers": "活跃用户",
  "pages.sdkUser.gameManagement.detail.table.retention1Day": "次日留存",
  "pages.sdkUser.gameManagement.detail.table.retention7Day": "7日留存",
  "pages.sdkUser.gameManagement.detail.table.adImpressions": "广告展示数",
  "pages.sdkUser.gameManagement.detail.table.adRevenue": "广告总收入",
  "pages.sdkUser.gameManagement.recommendation.saveButton": "保存推荐 ({count})",
  "pages.sdkUser.gameManagement.recommendation.clearButton": "清空推荐",
  "pages.sdkUser.gameManagement.recommendation.refreshButton": "刷新列表",
  "pages.sdkUser.gameManagement.recommendation.selectedGames": "已推荐游戏",
  "pages.sdkUser.gameManagement.recommendation.availableGames": "可选游戏",
  "pages.sdkUser.gameManagement.recommendation.dragHint": "拖拽可调整推荐顺序",
  "pages.sdkUser.gameManagement.recommendation.add": "添加",
  "pages.sdkUser.gameManagement.recommendation.remove": "移除",
  "pages.sdkUser.gameManagement.recommendation.updatedAt": "更新于 {date}",
  "pages.sdkUser.gameManagement.recommendation.searchPlaceholder": "搜索游戏",
  "pages.sdkUser.gameManagement.recommendation.categoryPlaceholder": "选择分类",
  "pages.sdkUser.gameManagement.recommendation.empty.selected": "暂无推荐游戏",
  "pages.sdkUser.gameManagement.recommendation.empty.available": "暂无可选游戏",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.title": "确认清空",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.content": "确定要清空所有推荐游戏吗？",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.ok": "确认",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.cancel": "取消",
  "pages.sdkUser.gameManagement.recommendation.clearSuccess": "清空成功",
  "pages.sdkUser.gameManagement.recommendation.warning.noSelection": "请先选择要推荐的游戏",
  "pages.sdkUser.gameManagement.recommendation.saveSuccess": "保存成功",
  "pages.sdkUser.gameManagement.recommendation.error.saveFailed": "保存失败",
  "pages.sdkUser.gameManagement.recommendation.error.noOperator": "无法获取操作员信息",

  "pages.sdkUser.gameManagement.tabs.customList": "自定义列表",
  "pages.sdkUser.gameManagement.customList.name.label": "列表名称",
  "pages.sdkUser.gameManagement.customList.name.placeholder": "请输入列表名称，如：Puzzle Masters",
  "pages.sdkUser.gameManagement.customList.name.required": "请输入列表名称",
  "pages.sdkUser.gameManagement.customList.name.invalid": "仅支持字母、数字和空格，两端不能有空格，中间不能有连续空格",
  "pages.sdkUser.gameManagement.customList.name.tooLong": "列表名称不能超过 50 个字符",
  "pages.sdkUser.gameManagement.customList.name.hint": "该名称会展示给玩家；仅支持字母、数字和空格",
  "pages.sdkUser.gameManagement.customList.mockNotice": "演示模式：自定义列表数据暂存在本地浏览器，后端接口就绪后自动切换为真实接口",
  "pages.sdkUser.gameManagement.customList.saveButton": "保存列表 ({count})",
  "pages.sdkUser.gameManagement.customList.clearButton": "清空列表",
  "pages.sdkUser.gameManagement.customList.refreshButton": "刷新列表",
  "pages.sdkUser.gameManagement.customList.selectedGames": "已选游戏",
  "pages.sdkUser.gameManagement.customList.availableGames": "可选游戏",
  "pages.sdkUser.gameManagement.customList.dragHint": "拖拽可调整顺序",
  "pages.sdkUser.gameManagement.customList.add": "添加",
  "pages.sdkUser.gameManagement.customList.remove": "移除",
  "pages.sdkUser.gameManagement.customList.updatedAt": "更新于 {date}",
  "pages.sdkUser.gameManagement.customList.searchPlaceholder": "搜索游戏",
  "pages.sdkUser.gameManagement.customList.empty.selected": "暂无已选游戏",
  "pages.sdkUser.gameManagement.customList.empty.available": "暂无可选游戏",
  "pages.sdkUser.gameManagement.customList.clearConfirm.title": "确认清空",
  "pages.sdkUser.gameManagement.customList.clearConfirm.content": "确定要清空当前列表中的所有游戏吗？",
  "pages.sdkUser.gameManagement.customList.clearConfirm.ok": "确认",
  "pages.sdkUser.gameManagement.customList.clearConfirm.cancel": "取消",
  "pages.sdkUser.gameManagement.customList.clearSuccess": "清空成功",
  "pages.sdkUser.gameManagement.customList.warning.noName": "请先填写正确的列表名称",
  "pages.sdkUser.gameManagement.customList.saveSuccess": "保存成功",
  "pages.sdkUser.gameManagement.customList.error.saveFailed": "保存失败",
  "pages.sdkUser.gameManagement.customList.error.loadFailed": "加载自定义列表失败",
  "pages.sdkUser.gameManagement.customList.error.noOperator": "无法获取操作员信息",

  // SDK User - API Documentation
  "pages.sdkUser.apiDocs.title": "API文档",
  "pages.sdkUser.apiDocs.description": "浏览我们全面的API文档和指南",
  "pages.sdkUser.apiDocs.category.gettingStarted": "入门指南",
  "pages.sdkUser.apiDocs.category.api": "API参考",
  "pages.sdkUser.apiDocs.category.guides": "开发指南",
  "pages.sdkUser.apiDocs.category.platforms": "平台指南",
  "pages.sdkUser.apiDocs.tag.beginner": "入门",
  "pages.sdkUser.apiDocs.tag.integration": "集成",
  "pages.sdkUser.apiDocs.tag.setup": "设置",
  "pages.sdkUser.apiDocs.tag.installation": "安装",
  "pages.sdkUser.apiDocs.tag.configuration": "配置",
  "pages.sdkUser.apiDocs.tag.platform": "平台",
  "pages.sdkUser.apiDocs.tag.api": "API",
  "pages.sdkUser.apiDocs.tag.reference": "参考",
  "pages.sdkUser.apiDocs.tag.methods": "方法",
  "pages.sdkUser.apiDocs.tag.auth": "认证",
  "pages.sdkUser.apiDocs.tag.security": "安全",
  "pages.sdkUser.apiDocs.tag.session": "会话",
  "pages.sdkUser.apiDocs.tag.error": "错误",
  "pages.sdkUser.apiDocs.tag.debug": "调试",
  "pages.sdkUser.apiDocs.tag.troubleshooting": "故障排除",
  "pages.sdkUser.apiDocs.tag.performance": "性能",
  "pages.sdkUser.apiDocs.tag.optimization": "优化",
  "pages.sdkUser.apiDocs.tag.best-practice": "最佳实践",
  "pages.sdkUser.apiDocs.tag.unity": "Unity",
  "pages.sdkUser.apiDocs.tag.cocos": "Cocos",
  "pages.sdkUser.apiDocs.tag.game-engine": "游戏引擎",
  "pages.sdkUser.apiDocs.tag.games": "游戏",
  "pages.sdkUser.apiDocs.tag.featured": "精选",
  "pages.sdkUser.apiDocs.tag.list": "列表",
  "pages.sdkUser.apiDocs.tag.ios": "iOS",
  "pages.sdkUser.apiDocs.tag.sdk": "SDK",
  "pages.sdkUser.apiDocs.tag.native": "原生",
  "pages.sdkUser.apiDocs.tag.android": "Android",
  "pages.sdkUser.apiDocs.category.guide": "开发指南",
  "pages.sdkUser.apiDocs.viewDetail": "查看详情",
  "pages.sdkUser.apiDocs.empty": "暂无文档",
  "pages.sdkUser.apiDocs.back": "返回列表",
  "pages.sdkUser.apiDocs.content": "文档内容",
  "pages.sdkUser.apiDocs.invalidId": "无效的文档ID",
  "pages.sdkUser.apiDocs.notFound": "文档不存在",
  "pages.sdkUser.apiDocs.loadFailed": "文档加载失败",

  // Common
  "pages.home.default.admin": "管理员",
  "pages.home.default.developer": "开发者",
  "pages.home.default.reviewer": "审核员",
  "pages.home.default.sdkUser": "SDK用户",
  "pages.home.times": "次",
};
